/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_IntroInputs */

const en_svc_integration_intro = /** @type {(inputs: Svc_Integration_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not need a new platform to use AI. We integrate language models into your existing CRM, email, documents and internal applications through their APIs, so AI does the reading, extracting and drafting where the work already happens.`)
};

const lv_svc_integration_intro = /** @type {(inputs: Svc_Integration_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lai izmantotu AI, nav vajadzīga jauna platforma. Mēs integrējam valodas modeļus Jūsu esošajā CRM, e-pastā, dokumentos un iekšējās lietotnēs caur to API, lai AI lasītu, iegūtu datus un sagatavotu tekstus tur, kur darbs jau notiek.`)
};

/**
* | output |
* | --- |
* | "You do not need a new platform to use AI. We integrate language models into your existing CRM, email, documents and internal applications through their APIs,..." |
*
* @param {Svc_Integration_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_intro = /** @type {((inputs?: Svc_Integration_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_intro(inputs)
	return en_svc_integration_intro(inputs)
});